"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.error = void 0;
const write_1 = __importDefault(require("../cli-ux/write"));
const config_1 = require("./config");
const cli_1 = require("./errors/cli");
const pretty_print_1 = __importStar(require("./errors/pretty-print"));
function error(input, options = {}) {
    let err;
    if (typeof input === 'string') {
        err = new cli_1.CLIError(input, options);
    }
    else if (input instanceof Error) {
        err = (0, cli_1.addOclifExitCode)(input, options);
    }
    else {
        throw new TypeError('first argument must be a string or instance of Error');
    }
    err = (0, pretty_print_1.applyPrettyPrintOptions)(err, options);
    if (options.exit === false) {
        const message = (0, pretty_print_1.default)(err);
        if (message)
            write_1.default.stderr(message + '\n');
        if (config_1.config.errorLogger)
            config_1.config.errorLogger.log(err?.stack ?? '');
    }
    else
        throw err;
}
exports.error = error;
exports.default = error;
